import { Button, Image, VStack } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { KYDAdminFeedItem } from "@common/interfaces/KYDOrganization";
import { FaCloudUploadAlt } from "react-icons/fa";

import placeholder from "../../placeholder.png";

const ImageUploadInputWithPreview = ({
  dirtyText,
  valueFrom,
  feedItem,
  onFileUploadSet,
  isDisabled = false,
}: {
  dirtyText: Record<string, any>;
  valueFrom: string;
  feedItem?: KYDAdminFeedItem;
  isDisabled?: boolean;
  onFileUploadSet: (file: File) => void;
}) => {
  const [image, setImage] = useState(placeholder);
  const inputUploadRef = useRef<HTMLInputElement>(null);

  const openFileUpload = () => {
    if (inputUploadRef && inputUploadRef.current) {
      inputUploadRef.current.click();
    }
  };

  useEffect(() => {
    if (dirtyText[`item.${valueFrom}`] || feedItem?.[valueFrom]) {
      setImage(null);
    }
  }, [dirtyText[`item.${valueFrom}`], feedItem?.[valueFrom]]);

  return (
    <VStack width={"full"} alignItems={"center"}>
      <Image
        rounded={"md"}
        maxH="200px"
        minH="200px"
        cursor="pointer"
        onClick={() => openFileUpload()}
        src={
          image
            ? image
            : `item.${valueFrom}` in dirtyText
            ? dirtyText[`item.${valueFrom}`]
            : feedItem?.[valueFrom]
        }
      />
      <input
        ref={inputUploadRef}
        type="file"
        onChange={(ev) => {
          const file = ev.target.files[0];

          if (file) {
            setImage(URL.createObjectURL(file));
            onFileUploadSet(file);
          }
        }}
        accept="image/png,image/jpg,image/jpeg"
        hidden
      />
      <Button
        onClick={() => {
          openFileUpload();
        }}
        aria-label="Upload image"
        variant={"outline"}
        isDisabled={isDisabled}
        leftIcon={<FaCloudUploadAlt />}
      >
        Upload image
      </Button>
    </VStack>
  );
};

export default ImageUploadInputWithPreview;
